import { ConsumptionRow } from "./consumptionRow";
import { EnergyDataStatus } from "./energyDataQuality";

export type StatusCounts = Record<EnergyDataStatus, number>;

const EMPTY: StatusCounts = { ok: 0, partial: 0, missing: 0, failed: 0, pending: 0 };

/**
 * Counts how many vehicles fall into each data-quality status.
 *
 * This is the number the report is opened for when it is being checked against real operation:
 * how much of the fleet Geotab actually answered for. Buried one vehicle at a time it is
 * unreadable, so it is summarised above the table.
 *
 * @param rows - The consumption rows.
 * @returns One count per status.
 */
export function countByStatus(rows: ConsumptionRow[]): StatusCounts {
  const counts = { ...EMPTY };
  for (const row of rows) {
    counts[row.status]++;
  }
  return counts;
}
